
const mobile = {}
module.exports = mobile
